import React, { useEffect, useState } from "react";
import { productsData } from "../../static/data";
import ProductCard from "../route/productCard/ProductCard";
import { Link, useParams } from "react-router-dom";
import styles from "../../styles/style";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsShop } from "../../redux/actions/productAction";
import { backend_url } from "../../server";
import Ratings from "../products/Ratings";
import { getAllEventsShop } from "../../redux/actions/eventAction";

const ShopProfileData = ({ isOwner }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [active, setActive] = useState(1);
  const { products } = useSelector((state) => state.products);
  const { events } = useSelector((state) => state.events);
  const { seller } = useSelector((state) => state.seller);

  useEffect(() => {
    if (id) {
      dispatch(getAllProductsShop(id));
      dispatch(getAllEventsShop(id));
    }
  }, [dispatch, id]);

  const allReviews =
    products && products.map((product) => product.reviews).flat();

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between">
        <div className="w-full flex">
          <div className="flex items-center" onClick={() => setActive(1)}>
            <h5
              className={`font-[600] text-[20px] ${
                active === 1 ? "text-red-500" : "text-[#3e3e3eba]"
              } cursor-pointer pr-[20px]`}
            >
              Shop Products
            </h5>
          </div>
          <div className="flex items-center" onClick={() => setActive(2)}>
            <h5
              className={`font-[600] text-[20px] ${
                active === 2 ? "text-red-500" : "text-[#3e3e3eba]"
              } cursor-pointer pr-[20px]`}
            >
              Running Events
            </h5>
          </div>
          <div className="flex items-center" onClick={() => setActive(3)}>
            <h5
              className={`font-[600] text-[20px] ${
                active === 3 ? "text-red-500" : "text-[#3e3e3eba]"
              } cursor-pointer pr-[20px]`}
            >
              Shop Reviews
            </h5>
          </div>
        </div>
        <div>
          {isOwner && (
            <div>
              <Link to="/dashboard">
                <div className={`${styles.button} !rounded-[4px] h-[42px]`}>
                  <span className="text-[#fff]">Go Dashboard</span>
                </div>
              </Link>
            </div>
          )}
        </div>
      </div>
      <br />
      {active === 1 && (
        <div className="grid grid-cols-1 gap-[20px] md:grid-cols-2 md:gap-[25px] lg:grid-cols-3 lg:gap-[25px] xl:grid-cols-4 xl:gap-[20px] mb-12 border-0">
          {products &&
            products.map((i) => (
              <ProductCard data={i} key={i?._id || i?.id} isShop={true} />
            ))}
        </div>
      )}

      {active === 2 && (
        <div className="w-full">
          {events && events.length > 0 ? (
            <div className="grid grid-cols-1 gap-[20px] md:grid-cols-2 md:gap-[25px] lg:grid-cols-3 lg:gap-[25px] xl:grid-cols-4 xl:gap-[20px] mb-12 border-0">
              {events.map((i) => (
                <ProductCard
                  data={i}
                  key={i?._id || i?.id}
                  isShop={true}
                  isEvent={true}
                />
              ))}
            </div>
          ) : (
            <h5 className="w-full text-center py-5 text-[18px]">
              No Events for this shop!
            </h5>
          )}
        </div>
      )}

      {active === 3 && (
        <div className="w-full">
          {allReviews && allReviews.length > 0 ? (
            allReviews.map((item, index) => (
              <div className="w-full flex my-4">
                <img
                  src={item.user.avatar?.url}
                  className="w-[50px] h-[50px] rounded-full"
                  alt=""
                />
                <div className=" w-full  pl-3">
                  <h1 className="font-[600] pr-2">{item.user.name}</h1>
                  <Ratings rating={item.rating} />
                  <p className="font-[400] text-[#3e3e3eba]">{item?.comment}</p>
                  <p className="text-[#3e3e3eba] text-[14px]">{"2 days ago"}</p>
                </div>
              </div>
            ))
          ) : (
            <h5 className="w-full text-center py-5 text-[18px]">
              No Reviews Yet!
            </h5>
          )}
        </div>
      )}

      {products && products.length === 0 && (
        <h5 className="w-full text-center py-5 text-[18px]">
          No Products have for this shop!
        </h5>
      )}
    </div>
  );
};

export default ShopProfileData;
